// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3cN_L","box":"WorkspacesBox_box__1WB-A","node":"WorkspacesBox_node__3nd19"};